import { Component, input } from '@angular/core';
import { Project } from '@app/models/project.models';
import { ProjectCardComponent } from '@app/ui-components/project-card/project-card.component';

@Component({
  selector: 'app-project-grid',
  templateUrl: './project-grid.component.html',
  styleUrl: './project-grid.component.scss',
  imports: [ProjectCardComponent],
})
export class ProjectGridComponent {
  public projects = input.required<Project[]>();
}
